import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HttpHandler, HttpRequest,
  HttpEvent, HttpResponse, HttpErrorResponse, HTTP_INTERCEPTORS, HttpHeaders
} from '@angular/common/http';
import { Observable, throwError, of, BehaviorSubject, Subject } from "rxjs";
import { catchError, switchMap, take, filter } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { MessageService } from 'src/app/_theme/components/message/message.service';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from './../../_config/config';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {
  private refreshTokenInProgress = false;
  private refreshTokenSubject: Subject<any> = new BehaviorSubject<any>(null);

 gateway = this.config.gateway;

  constructor(
    private _notification: MessageService,
    public toasterService: ToastrService,
    private http: HttpClient,
    private config: CONFIG
  ) {

  }

  intercept(req, next) {
    // console.log('Solicitud Interceptor: ', req);
    let headers;
        const objectUser = {
      'username' : 'demojwt-client',
      'password' : 'demojwt-secret'
    };
    let db = sessionStorage.getItem('database')
    const userEncript = btoa(sessionStorage.getItem('user'));
    const dataBaseEncript = btoa(sessionStorage.getItem('database'));
    const credenciales = btoa(objectUser.username + ':' + objectUser.password);
    const token: string = (sessionStorage.getItem('token')) === null ? '' : JSON.parse(sessionStorage.getItem('token')).access_token;
    const database: string = sessionStorage.getItem('database') === null ? 'SECURITY' :sessionStorage.getItem('database');
    const userOn: string = sessionStorage.getItem('user') === null ? '' : JSON.parse(sessionStorage.getItem('user'));
    if(database === 'SECURITY'){
      headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Basic ' + credenciales
      });
    }else{
      //Se implemento esta validacion ya que ICP aun no tiene los ajustes de multisite

      if (req.body){
        if (req.body.external){
            console.log('SOLICITUD EXTERNA', req.body.external);
            db= 'LBVICP'
        }
      }
      headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'db':db
      });
    }

    const authReq = req.clone({ headers });
    return next.handle(authReq);
    
  }

  private addTokenToRequest(request: HttpRequest<any>, token: string, database: string, userOn: string) {
    return request.clone({
      setHeaders: {
        //'DataBase': database,
        'UserOn': userOn,
        'token': token
      }
    });
  }

/*
  handleUnauthorized(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
// funcion utilizada para refrescar token. Su estado no es funcional ya que desde el backend no estan refrescando token.

    console.log("function handleUnauthorized ");

    if (!this.refreshTokenInProgress) {
      this.refreshTokenInProgress = true;

      // Reset here so that the following requests wait until the token
      // comes back from the refreshToken call.
      this.refreshTokenSubject.next(null);
      // get a new token via userService.refreshToken
      //const token: string = (sessionStorage.getItem('token')) === null ? '' : JSON.parse(sessionStorage.getItem('token')).access_token;
      return this.http.get(`${this.gateway.url}/master/check`)
        .pipe(switchMap((newToken: string) => {
          // did we get a new token retry previous request
          console.log("data newToken ", newToken);
          if (newToken) {
            this.refreshTokenInProgress = false;
            this.refreshTokenSubject.next(newToken);
            const database: string = sessionStorage.getItem('database') === null ? 'SECURITY' : JSON.parse(sessionStorage.getItem('database'));
            const userOn: string = sessionStorage.getItem('user') === null ? '' : JSON.parse(sessionStorage.getItem('user'));

            return next.handle(this.addTokenToRequest(req, newToken, database, userOn));
          }
          // If we don't get a new token, we are in trouble so logout.
          console.log("No data in refresh token");
          //return null;

        })
          , catchError(err => {
            // If there is an exception calling 'refreshToken', bad news so logout.
            //this.userService.doLogout();
            console.log("CatchError ", err);
            this._notification.create("error", `Error:  ${err.error.error} , ${err.message}`, { Position: "bottom-right", Style: "simple", Duration: 8000 });
            return of(err);
          })
        );
    } else {
      return this.refreshTokenSubject
        .pipe(
          filter(token => token != null)
          , take(1)
          , switchMap(token => {
            console.log("Else handleUnauthorized ");
            const database: string = sessionStorage.getItem('database') === null ? 'SECURITY' : JSON.parse(sessionStorage.getItem('database'));
            const userOn: string = sessionStorage.getItem('user') === null ? '' : JSON.parse(sessionStorage.getItem('user'));

            return next.handle(this.addTokenToRequest(req, "newToken", database, userOn));
          })
        );
    }
  }*/


}
